import { useEffect, useMemo, useState } from "react";
import { FaFilter } from "react-icons/fa";
import Modal from "./Modal";
import nuethreads from "../../assets/images/nuethreads.png";
import "./PayIn.css";
import Pagination from "./Pagination";
import {
  getInvoice,
  getOrganisation,
  getUser,
  payinData,
} from "../../config/LiveApi";
import Spinner from "../Spin/Spinner";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { getProductCombinations } from "./productGeneration";
import { useSelector } from "react-redux";
import { MdContentCopy } from "react-icons/md";
import { toast } from "react-toastify";
import Select from "react-select";

function ReportTable({
  isLoading,
  currentItems,
  totalPages,
  currentPage,
  setCurrentPage,
  setStatus,
  allData,
  setCurrentItems,
  startDate,
  endDate,
  tableData,
}) {
  const token = useSelector((store) => store.userReducer.token);
  const [showTransactionMode, setShowTransactionMode] = useState(false);
  const [transactionModeFilter, setTransactionModeFilter] = useState("");
  const [showTransactionType, setShowTransactionType] = useState(false);
  const role = useSelector((store) => store.userReducer.role);
  // const [page, setPage] = useState(1);
  const [showStatus, setShowStatus] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [orgName, setOrgName] = useState(false);
  const [orgOptions, setOrgOptions] = useState([]);
  const [selectedOrgName, setSelectedOrgName] = useState("All");
  const [listofusers, setListofUser] = useState([]);
  const [businessName, setBusinessName] = useState(false);
  const [statusOpen, setStatusOpen] = useState(false);
  const [selectedBusinessName, setSelectedBusinessName] = useState("All");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [loading, setLoading] = useState(false);

  const businessOptions = useMemo(() => {
    if (!Array.isArray(listofusers)) return [];

    return listofusers.map((user) => ({
      value: user.id,
      label: user?.alias || user?.id,
    }));
  }, [listofusers]);

  const orgSelectOptions = useMemo(() => {
    if (!Array.isArray(orgOptions)) return [];

    return orgOptions.map((org) => ({
      value: org.orgName,
      label: org.orgName,
    }));
  }, [orgOptions]);

  const dataToShow = tableData.length > 0 ? tableData : currentItems;

  useEffect(() => {
    const fetchOrganisations = async () => {
      try {
        if (role === "mops" || role === "admin" || role === "subAdmin") return;
        const response = await getOrganisation(token);
        const orgData = response.data;
        setOrgOptions(orgData);
      } catch (err) {
        console.error("Error fetching organisations:", err.message);
      }
    };

    fetchOrganisations();
  }, [token]);

  const fetchUsers = async (page) => {
    try {
      if(role === "admin" || role === "mops" || role === "subAdmin") return;
      const response = await getUser(token);
      const data = response?.data;
      const adminUsers = data.filter((user) => user.role === "admin");
      // console.log("adminUsersadminUsers",adminUsers)
      setListofUser(adminUsers);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const viewData = (item, setModalData, setOpenModal) => {
    setModalData(item);
    setOpenModal(true);
  };

  const compareDates = (a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);
    return dateB - dateA; // Sort in descending order for most recent first
  };

  const generatePDF = async (item) => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageHeight = doc.internal.pageSize.height;

    const img = new Image();
    img.src = nuethreads;

    doc.addImage(img, "PNG", 3, 3, 32, 14);

    const transactionID = item.transactionId;
    const date = new Date(item.createdAt);
    const day = date.getDate();
    const startDate = new Date(date);
    startDate.setDate(date.getDate() + 3);

    const endDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000);

    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    const customerName = item.dataItem.customerName;
    const phoneNumber = item.dataItem.customerMobile;
    const email = item.dataItem.customerEmail;
    const amount = item.dataItem.amount;

    const payoutData = await getInvoice(
      token,
      transactionID,
      startDate.toISOString(),
      endDate.toISOString()
    );

    const productInfo = getProductCombinations(amount);
    const productList = productInfo.products;
    const discount = productInfo.balance;

    if (!("count" in payoutData)) {
      alert("Payout not available for the selected payin!!!");
      return;
    }
    const invoice = payoutData.count;

    payoutData.name = payoutData.name === undefined ? "" : payoutData.name;
    payoutData.email = payoutData.email === undefined ? "" : payoutData.email;

    doc.setFontSize(18);
    doc.text("BILL INVOICE", 105, 10, null, null, "center");

    doc.setFont("helvetica", "bold");
    doc.setFillColor(210);
    doc.text("Stretavia Media Private Limited", 105, 20, null, null, "center");

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0);
    doc.text(
      "House No. 101 A-01/3, Anupam Bhawan, Azadpur Underpass, New Delhi - 110033",
      105,
      25,
      null,
      null,
      "center"
    );
    doc.text("Phone: +91 9675497136", 60, 30);
    doc.text("GSTIN: 07ABOCS5608J1ZV", 110, 30);

    doc.setFontSize(12);
    doc.text("BILL TO:", 10, 60);
    doc.setFont("helvetica", "bold");
    doc.text(`${customerName} (Buyer)`, 10, 70);
    doc.setFont("helvetica", "normal");
    doc.text(`Phone: ${phoneNumber}`, 10, 75);
    doc.text(`Email: ${email}`, 10, 80);

    doc.setFontSize(11);
    doc.text(`Invoice No: NT/${day}-${month}-${year}/${invoice}`, 20, 40);
    doc.text(`Invoice Date: ${formattedDate}`, 20, 45);

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(`${payoutData.name} (Seller)`, 120, 70);
    doc.setFont("helvetica", "normal");
    doc.text(`Email: ${payoutData.email}`, 120, 75);

    doc.setFillColor(216, 18, 93);
    doc.rect(10, 90, 190, 8, "F");
    doc.setTextColor(255);
    doc.text("Sr. No.", 12, 95);
    doc.text("Items", 35, 95);
    doc.text("Quantity", 85, 95);
    doc.text("Price / Unit", 115, 95);
    doc.text("Amount", 175, 95);

    doc.setTextColor(0);

    let yPosition = 105;
    let totalCount = 0;
    let totalAmount = 0;

    Object.entries(productList).forEach(([itemName, product], index) => {
      const price = parseFloat(product.price);
      const quantity = parseInt(product.quantity, 10);
      const totalPrice = price * quantity;

      const maxItemNameWidth = 45;
      const splitItemName = doc.splitTextToSize(itemName, maxItemNameWidth);
      const itemNameHeight = splitItemName.length * 5;

      if (yPosition + itemNameHeight + 10 > pageHeight - 20) {
        doc.addPage();
        yPosition = 20;
        doc.setFillColor(216, 18, 93);
        doc.rect(10, 10, 190, 8, "F");
        doc.setTextColor(255);
        doc.text("Sr. No.", 12, 15);
        doc.text("Items", 35, 15);
        doc.text("Quantity", 85, 15);
        doc.text("Price / Unit", 115, 15);
        doc.text("Amount", 175, 15);
        doc.setTextColor(0);
      }

      doc.text(`${index + 1}`, 12, yPosition);

      splitItemName.forEach((line, lineIndex) => {
        doc.text(line, 35, yPosition + lineIndex * 5);
      });

      doc.text(`${quantity}`, 85, yPosition);
      doc.text(`Rs. ${price}`, 115, yPosition);
      doc.text(`Rs. ${totalPrice}`, 175, yPosition);

      totalCount += Number(quantity);
      totalAmount += Number(totalPrice);

      yPosition += itemNameHeight + 5;
    });

    if (yPosition + 30 > pageHeight - 20) {
      doc.addPage();
      yPosition = 20;
    }

    doc.setFillColor(216, 18, 93);
    doc.rect(10, yPosition, 190, 8, "F");
    doc.setTextColor(255);
    doc.text("Total", 35, yPosition + 5);
    doc.text(`${totalCount}`, 85, yPosition + 5);
    doc.text(`Rs. ${totalAmount}`, 175, yPosition + 5);

    yPosition += 15;

    doc.setTextColor(0);
    doc.text("Discount", 10, yPosition);
    doc.text(`Rs. ${discount}`, 175, yPosition);

    yPosition += 10;

    doc.text("Received Amount", 10, yPosition);
    doc.text(`Rs. ${amount}`, 175, yPosition);

    yPosition += 30;

    doc.text("Terms & Conditions:", 20, yPosition);
    doc.text(
      "1. Customer will pay the delivery charges, if applicable",
      20,
      yPosition + 5
    );
    doc.text(
      "2. GST liability, if any, will be borne by seller only.",
      20,
      yPosition + 10
    );
    doc.text(
      "3. All disputes are subject to Delhi Jurisdiction.",
      20,
      yPosition + 15
    );

    yPosition += 20;

    if (yPosition + 10 > pageHeight - 20) {
      doc.addPage();
      yPosition = 20;
    }

    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    doc.text(
      "*This is a computer generated invoice, no stamp or signature is required.",
      100,
      yPosition
    );

    const fileName = `Invoice_NT/${day}-${month}-${year}/${invoice}.pdf`;

    doc.save(fileName);
  };

  const exportPdfHandler = () => {
    //  doc.autoTable({html : 'transaction-table'})
    //  doc.save('Transactions.pdf')

    const doc = new jsPDF({ orientation: "landscape" });
    doc.autoTable({
      html: "#transaction-table",
    });
    doc.save("Transaction.pdf");
  };

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      try {
        const response = await payinData(
          token,
          currentPage,
          startDate,
          endDate,
          selectedOrgName === "All" ? "" : selectedOrgName,
          selectedBusinessName === "All" ? "" : selectedBusinessName,
          selectedStatus === "All" ? "" : selectedStatus
        );
        // console.log("Response for filter:", response);

        setCurrentItems(response);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [
    startDate,
    endDate,
    selectedOrgName,
    selectedBusinessName,
    currentPage,
    setCurrentItems,
    token,
    selectedStatus,
  ]);

  return (
    <>
      <div className="exp-div">
        {/* <button className="exp-but" onClick={exportPdfHandler}>
          Export
        </button> */}
        {/* <TableExportButton allData={allData} fileName="PayIn" /> */}
      </div>
      <div
        className="table-main-report"
        style={{
          maxHeight: "600px",
          position: "sticky",
          padding: "0px 10px 0px 10px",
        }}
      >
        {isLoading ? (
          <Spinner />
        ) : dataToShow?.length > 0 ? (
          <table
            className="table-user-management"
            id="transaction-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <thead
              className="table-user-report"
              style={{
                position: "sticky",
                top: "0",
                zIndex: "999",
              }}
            >
              <tr>
                {(role == "super" ||
                  role == "operation" ||
                  role == "trafficManager" ||
                  role == "subSuper") && (
                  <th className="filter-pos">
                    <div className="data-icon">
                      <p className="user-table-head-report">Org Name</p>
                      <FaFilter
                        style={{
                          marginRight: "0.2rem",
                          width: "1rem",
                          height: "1rem",
                          cursor: "pointer",
                        }}
                        onMouseEnter={() => setOrgName(true)}
                        onMouseLeave={() => setOrgName(false)}
                      />
                    </div>
                    {orgName && (
                      <div
                        className="transfer-mode"
                        style={{
                          padding: "4px",
                          minWidth: "200px",
                          width: "max-content",
                          maxWidth: "90vw",
                        }}
                        onMouseEnter={() => setOrgName(true)}
                        onMouseLeave={(e) => {
                          if (e.relatedTarget?.closest?.(".transfer-mode"))
                            return;
                          setOrgName(false);
                        }}
                      >
                        <Select
                          options={[
                            { value: "All", label: "All" },
                            ...(orgSelectOptions?.length
                              ? orgSelectOptions
                              : []),
                          ]}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Search Org..."
                          isClearable
                          // isLoading={isOrgLoading}
                          // noOptionsMessage={() =>
                          //   isOrgLoading ? "Loading..." : "No org found"
                          // }
                          menuPlacement="auto"
                          onChange={(option) => {
                            setSelectedOrgName(option?.value || "All");
                            setOrgName(false);
                          }}
                          styles={{
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                            control: (base) => ({
                              ...base,
                              minHeight: "32px",
                              height: "32px",
                            }),
                            indicatorsContainer: (base) => ({
                              ...base,
                              height: "32px",
                            }),
                          }}
                        />
                      </div>
                    )}
                  </th>
                )}
                {(role == "super" ||
                  role == "operation" ||
                  role == "trafficManager" ||
                  role == "subSuper") && (
                  <th className="filter-pos">
                    <div className="data-icon">
                      <p className="user-table-head-report">Business Name</p>
                      <FaFilter
                        style={{
                          marginRight: "0.2rem",
                          width: "1rem",
                          height: "1rem",
                          cursor: "pointer",
                        }}
                        onMouseEnter={() => setBusinessName(true)}
                        onMouseLeave={() => setBusinessName(false)}
                      />
                    </div>
                    {businessName && (
                      <div
                        className="transfer-mode"
                        onMouseEnter={() => setBusinessName(true)}
                        onMouseLeave={(e) => {
                          if (e.relatedTarget?.closest?.(".transfer-mode"))
                            return;
                          setBusinessName(false);
                        }}
                      >
                        <div
                          style={{
                            width: "220px",
                            padding: "0.5rem",
                          }}
                          onMouseEnter={() => setBusinessName(true)}
                          onMouseLeave={(e) => {
                            if (e.relatedTarget?.closest?.(".transfer-mode"))
                              return;
                            setBusinessName(false);
                          }}
                        >
                          <Select
                            options={[
                              { value: "All", label: "All" },
                              ...businessOptions,
                            ]}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            placeholder="Search Business..."
                            isClearable
                            menuPlacement="auto"
                            onChange={(option) => {
                              setSelectedBusinessName(option?.value || "All");
                              setBusinessName(false);
                            }}
                            styles={{
                              menu: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({
                                ...base,
                                minHeight: "32px",
                                height: "32px",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                height: "32px",
                              }),
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </th>
                )}

                {(role == "super" ||
                  role == "operation" ||
                  role == "trafficManager" ||
                  role == "subSuper") && (
                  <th>
                    <p className="user-table-head-report">PG Name</p>
                  </th>
                )}

                <th className="filter-pos">
                  <div className="data-icon" style={{ width: "130px" }}>
                    <p className="user-table-head-report">Order Id</p>
                  </div>
                  {showTransactionType && (
                    <div
                      className="transfer-mode"
                      onMouseEnter={() => setShowTransactionType(true)}
                      onMouseLeave={() => setShowTransactionType(false)}
                    >
                      <p>Debit</p>
                      <p>Credit</p>
                    </div>
                  )}
                </th>
                <th className="filter-pos">
                  <div className="data-icon">
                    <p className="user-table-head-report">Transaction Mode</p>
                    <FaFilter
                      style={{
                        marginRight: "0.2rem",
                        width: "1rem",
                        height: "1rem",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setShowTransactionMode(!showTransactionMode)
                      }
                    />
                  </div>
                  {showTransactionMode && (
                    <div
                      className="transfer-mode"
                      onMouseLeave={() => setShowTransactionMode(false)}
                    >
                      <p onClick={() => setTransactionModeFilter("")}>All</p>
                      <p onClick={() => setTransactionModeFilter("UPI_INTENT")}>
                        UPI_INTENT
                      </p>
                      <p onClick={() => setTransactionModeFilter("IMPS")}>
                        IMPS
                      </p>
                      <p onClick={() => setTransactionModeFilter("NEFT")}>
                        NEFT
                      </p>
                    </div>
                  )}
                </th>
                <th>
                  <p className="user-table-head-report">Amount(₹)</p>
                </th>

                <th>
                  <p className="user-table-head-report">Comm.(₹)</p>
                </th>
                <th>
                  <p className="user-table-head-report">Rolling Reserve(₹)</p>
                </th>

                <th className="filter-pos">
                  <div className="data-icon">
                    <p className="user-table-head-report">Status</p>
                    <FaFilter
                      style={{
                        marginRight: "0.2rem",
                        width: "1rem",
                        height: "1rem",
                        cursor: "pointer",
                      }}
                      onMouseEnter={() => setStatusOpen(true)}
                      onMouseLeave={() => setStatusOpen(false)}
                    />
                  </div>
                  {statusOpen && (
                    <div
                      className="status-mode"
                      onMouseEnter={() => setStatusOpen(true)}
                      onMouseLeave={() => setStatusOpen(false)}
                    >
                      <p
                        onClick={() => {
                          setSelectedStatus("All");
                          setStatusOpen(false);
                        }}
                      >
                        All
                      </p>
                      <p
                        onClick={() => {
                          setSelectedStatus("SUCCESS");
                          setStatusOpen(false);
                        }}
                      >
                        Success
                      </p>
                      <p
                        onClick={() => {
                          setSelectedStatus("PROCESSING");
                          setStatusOpen(false);
                        }}
                      >
                        Processing
                      </p>
                      <p
                        onClick={() => {
                          setSelectedStatus("FAILED");
                          setStatusOpen(false);
                        }}
                      >
                        Failed
                      </p>
                    </div>
                  )}
                </th>
                <th>
                  <p className="user-table-head-report">Transaction Date</p>
                </th>
                <th>
                  <p className="user-table-head-report">Updated Date</p>
                </th>
                <th>
                  <p className="user-table-head-report">Action</p>
                </th>

                {(role === "super" ||
                  role === "operation" ||
                  role == "subSuper") && (
                  <th>
                    <p className="user-table-head-report">Invoice</p>
                  </th>
                )}
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center" }}>
                    <Spinner />
                  </td>
                </tr>
              ) : (
                dataToShow &&
                dataToShow.length > 0 &&
                dataToShow.map((item, i) => {
                  const dataItem = JSON.parse(item.request);
                  const responseData = JSON.parse(item.resposne);
                  item.dataItem = dataItem;
                  item.responseData = responseData;
                  const dateString = item.createdAt;
                  const date = new Date(dateString);
                  const day = date.getDate();
                  const month = date.getMonth() + 1;
                  const year = date.getFullYear();
                  const hours = date.getHours();
                  const minutes = date.getMinutes();
                  const seconds = date.getSeconds();
                  const formattedDate = `${day}-${month}-${year}`;
                  const formattedTime = `${hours}:${minutes}:${seconds}`;
                  const commission =
                    (item &&
                      item.resposne.AMOUNT &&
                      item.resposne.AMOUNT * item?.totalComission) / 100;
                  return item.responseStatus == "INVALID" ? (
                    ""
                  ) : (
                    <tr key={i} className="user-table-head-report">
                      {(role == "super" ||
                        role == "operation" ||
                        role == "trafficManager" ||
                        role == "subSuper") && (
                        <td>
                          <p className="table-user-data-report order-break">
                            {item.orgName ? item.orgName : "N/A"}
                          </p>
                        </td>
                      )}

                      {(role == "super" ||
                        role == "operation" ||
                        role == "trafficManager" ||
                        role == "subSuper") && (
                        <td>
                          <p className="table-user-data-report order-break payin-report-table">
                            {item?.alias || item?.userId}
                          </p>
                        </td>
                      )}
                      {(role == "super" ||
                        role == "operation" ||
                        role == "trafficManager" ||
                        role == "subSuper") && (
                        <td>
                          <p className="table-user-data-report order-break">
                            {item.pg ? item.pg : ""}
                          </p>
                        </td>
                      )}

                      <td>
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <p className="table-user-data-report order-break">
                            {item && item.dataItem && item.dataItem.orderId
                              ? item.dataItem.orderId
                              : ""}
                          </p>
                          <MdContentCopy
                            className="copy-icon-payin-report"
                            onClick={() => {
                              navigator.clipboard.writeText(
                                item.dataItem.orderId
                              );
                              item.dataItem.orderId &&
                                toast.success("Copied OrderId to Clipboard");
                            }}
                          />
                        </span>
                      </td>
                      <td>
                        <p className="table-user-data-report order-break">
                          {dataItem && dataItem.transactionMode
                            ? dataItem.transactionMode
                            : ""}
                        </p>
                      </td>
                      <td>
                        <p className="table-user-data-report">
                          {item && item.dataItem.amount && item.dataItem.amount}
                        </p>
                      </td>

                      <>
                        <td>
                          <p className="table-user-data-report status-table order-break">
                            {item.responseStatus === "SUCCESS"
                              ? item.totalComission
                              : 0}
                          </p>
                        </td>

                        <td>
                          <p className="table-user-data-report status-table">
                            {item.responseStatus === "SUCCESS"
                              ? item.rollingReserve
                              : 0}
                          </p>
                        </td>
                      </>
                      <td>
                        <p
                          className="table-user-data-report status-table"
                          style={{
                            color:
                              item.responseStatus === "SUCCESS"
                                ? "green"
                                : item.responseStatus === "FAILED"
                                  ? "red"
                                  : item.responseStatus === "PROCESSING"
                                    ? "orange"
                                    : "black",
                            fontWeight: "bold",
                          }}
                        >
                          {item && item.responseStatus}
                        </p>
                      </td>

                      <td>
                        <p className="table-user-data-report status-table">
                          {formattedDate} {formattedTime}
                        </p>
                      </td>
                      <td>
                        <p className="table-user-data-report status-table">
                          {(() => {
                            const date = new Date(item.updatedAt);
                            const formattedDate = `${date.getDate()}-${
                              date.getMonth() + 1
                            }-${date.getFullYear()}`;
                            const formattedTime = `${date
                              .getHours()
                              .toString()
                              .padStart(2, "0")}:${date
                              .getMinutes()
                              .toString()
                              .padStart(2, "0")}:${date
                              .getSeconds()
                              .toString()
                              .padStart(2, "0")}`;
                            return `${formattedDate} ${formattedTime}`;
                          })()}
                        </p>
                      </td>
                      <td>
                        <button
                          className="view-btn"
                          onClick={() =>
                            viewData(item, setModalData, setOpenModal)
                          }
                        >
                          View
                        </button>
                      </td>

                      {(role === "super" ||
                        role === "operation" ||
                        role == "subSuper") && (
                        <td>
                          <button
                            className="generate-btn"
                            onClick={() => generatePDF(item)}
                          >
                            Generate
                          </button>
                        </td>
                      )}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        ) : (
          <div>
            <div className="dummy">
              {(role == "super" ||
                role == "operation" ||
                role == "trafficManager") && (
                <div className="filter-pos">
                  <div className="data-icon">
                    <p className="user-table-head-report">Org Name</p>
                    <FaFilter
                      style={{
                        marginRight: "0.2rem",
                        width: "1rem",
                        height: "1rem",
                        cursor: "pointer",
                      }}
                      onMouseEnter={() => setOrgName(true)}
                      onMouseLeave={() => setOrgName(false)}
                    />
                  </div>
                  {orgName && (
                    <div
                      className="transfer-mode"
                      style={{
                        padding: "4px",
                        minWidth: "200px",
                        width: "max-content",
                        maxWidth: "90vw",
                      }}
                      onMouseEnter={() => setOrgName(true)}
                      onMouseLeave={(e) => {
                        if (e.relatedTarget?.closest?.(".transfer-mode"))
                          return;
                        setOrgName(false);
                      }}
                    >
                      <Select
                        options={[
                          { value: "All", label: "All" },
                          ...(orgSelectOptions?.length ? orgSelectOptions : []),
                        ]}
                        placeholder="Search Org..."
                        isClearable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        onChange={(option) => {
                          setSelectedOrgName(option?.value || "All");
                          setOrgName(false);
                        }}
                        styles={{
                          menu: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({
                            ...base,
                            minHeight: "32px",
                            height: "32px",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "32px",
                          }),
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
              {(role == "super" || role == "operation") && (
                <div className="filter-pos">
                  <div className="data-icon">
                    <p className="user-table-head-report">Business Name</p>
                    <FaFilter
                      style={{
                        marginRight: "0.2rem",
                        width: "1rem",
                        height: "1rem",
                        cursor: "pointer",
                      }}
                      onMouseEnter={() => setBusinessName(true)}
                      onMouseLeave={() => setBusinessName(false)}
                    />
                  </div>
                  {businessName && (
                    <div
                      className="transfer-mode"
                      style={{ padding: "6px", minWidth: "220px" }}
                      onMouseEnter={() => setBusinessName(true)}
                      onMouseLeave={(e) => {
                        if (e.relatedTarget?.closest?.(".transfer-mode"))
                          return;
                        setBusinessName(false);
                      }}
                    >
                      <Select
                        options={[
                          { value: "All", label: "All" },
                          ...(businessOptions?.length ? businessOptions : []),
                        ]}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        placeholder="Search Business..."
                        isClearable
                        menuPlacement="auto"
                        onChange={(option) => {
                          setSelectedBusinessName(option?.value || "All");
                          setBusinessName(false);
                        }}
                        styles={{
                          menu: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({
                            ...base,
                            minHeight: "32px",
                            height: "32px",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "32px",
                          }),
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
              <div className="dummy-2">Ref Id</div>
              <div className="dummy-2">Order Id</div>
              <div className="dummy-2">Transaction Mode</div>
              <div className="dummy-2">Commission</div>
              <div className="dummy-2">
                {" "}
                <div className="data-icon filter-pos">
                  <p className="user-table-head-report">Status</p>

                  <FaFilter
                    style={{
                      marginRight: "0.2rem",
                      width: "1rem",
                      height: "1rem",
                      cursor: "pointer",
                    }}
                    onMouseEnter={() => setShowStatus(true)}
                    onMouseLeave={() => setShowStatus(false)}
                  />
                </div>
                {showStatus && (
                  <div
                    className="status-mode-1"
                    onMouseEnter={() => setShowStatus(true)}
                    onMouseLeave={() => setShowStatus(false)}
                  >
                    <p onClick={() => setSelectedStatus("")}>All</p>
                    <p onClick={() => setSelectedStatus("SUCCESS")}>Success</p>
                    <p onClick={() => setSelectedStatus("PROCESSING")}>
                      Processing
                    </p>
                    <p onClick={() => setSelectedStatus("FAILED")}>Failed</p>
                  </div>
                )}
              </div>
              <div className="dummy-2">Date</div>
              <div className="dummy-2">Action</div>
            </div>

            <div className="no-data">
              <div className="no-data-2">
                <p>No Data Found</p>
              </div>
            </div>
          </div>
        )}
        {currentItems && (
          <div>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            />
          </div>
        )}
      </div>

      {openModal && modalData && (
        <Modal modalData={modalData} setOpenModal={setOpenModal} />
      )}
    </>
  );
}

export default ReportTable;